module.exports = __webpack_public_path__ + "static/media/converted.23e8d826.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/converted.png
// module id = 48
// module chunks = 0